import { Injectable } from '@angular/core';
import { BookingAnalyticsEventData } from './tracking.model';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  pushEventToDataLayer(analyticsEventName: string, data: string): void {
    (window as any).dataLayer = (window as any).dataLayer || [];
    const dataLayer: any[] = (window as any).dataLayer;
    const gtmTag = {
      event: analyticsEventName,
      data: data,
    };
    if (!dataLayer.some(dataLayerEntry => dataLayerEntry.data === gtmTag.data)) {
      dataLayer.push(gtmTag);
    }
  }

  pushEventObjectToDataLayer(analyticsEventName: string, data: BookingAnalyticsEventData): void {
    (window as any).dataLayer = (window as any).dataLayer || [];
    const dataLayer: any[] = (window as any).dataLayer;
    const gtmTag = {
      event: analyticsEventName,
      ...data,
    };

    const removeIdProperty = ({
      'gtm.uniqueEventId': _,
      ...rest
    }: {
      'gtm.uniqueEventId': number;
      [key: string]: string | number;
    }): Record<string, string | number> => rest;

    if (!dataLayer.some(dataLayerEntry => stringify(removeIdProperty(dataLayerEntry)) === stringify(gtmTag))) {
      dataLayer.push(gtmTag);
    }
  }

  pushCallStepToDataLayer(analyticsEventName: string, step: string): void {
    this.pushStepToDataLayer(analyticsEventName, step, 'Aufruf');
  }

  pushFocusInputFieldEventToDataLayer(analyticsEventName: string, step: string, inputFieldName: string): void {
    this.pushStepToDataLayer(analyticsEventName, step, 'Klick Eingabefeld - ' + inputFieldName);
  }

  pushButtonClickToDataLayer(analyticsEventName: string, step: string, buttonText: string): void {
    this.pushStepToDataLayer(analyticsEventName, step, 'Klick - ' + buttonText);
  }

  private pushStepToDataLayer(analyticsEventName: string, step: string, action: string): void {
    if (!analyticsEventName) {
      return;
    }
    (window as any).dataLayer = (window as any).dataLayer || [];
    const dataLayer: any[] = (window as any).dataLayer;
    const gtmTag = {
      event: analyticsEventName,
      step: step,
      action: action,
    };
    if (
      !dataLayer.some(
        dataLayerEntry =>
          dataLayerEntry.step === gtmTag.step &&
          dataLayerEntry.action === gtmTag.action &&
          dataLayerEntry.event === gtmTag.event
      )
    ) {
      dataLayer.push(gtmTag);
    }
  }
}

function stringify(obj: Record<string, string | number>): string {
  let cache: (string | number)[] | null = [];
  const str = JSON.stringify(obj, function (key, value) {
    if (typeof value === 'object' && value !== null) {
      if (cache?.indexOf(value) !== -1) {
        // Circular reference found, discard key
        return;
      }
      // Store value
      cache.push(value);
    }
    return value;
  });
  cache = null; // reset the cache
  return str;
}
